export const RegexConstants = {
  Number: /^[0-9]*$/,
  Hours: /^(?:[01]?[0-9]|2[0-3]|)$/,
  Minute: /^(?:[0-5]?[0-9]|59)$/,
};

export const REGEX_NUMERIC = /^\d{0,9}(\.\d{0,2})?$/;

export const BARCODE_LENGTH = 13;
